<template>
<keep-alive>
<TopPanel />
 </keep-alive>
<div  v-if="ustore.uData.role == 'service_role'"  class="blog-container" @scroll="checkScrollPosition">
    <div class="main-content">
      <div class="subtopic-menu">
          <div class="subtopic-element" v-for="subtopic in course.lesson" :key="subtopic.id" :id="subtopic.id" v-bind:class="{'highlighted-tab':selectedTab==subtopic,'normal-tab': selectedTab!=subtopic}" @click="highlightTab(subtopic)">
            
            <div >{{ subtopic.name }}<span v-show="subtopic.completed" class="pi pi-check-circle" style="color: #00b300;float:right"></span> </div>
          </div>
      </div>
       <div v-bind:class="{'col-subtopic-menu':burgerCon,'exp-subtopic-menu': !burgerCon}">
          <div class="subtopic-element" v-for="subtopic in course.lesson" :key="subtopic.id" :id="subtopic.id" v-bind:class="{'highlighted-tab':selectedTab==subtopic,'normal-tab': selectedTab!=subtopic}" @click="highlightTab(subtopic)">
            {{ subtopic.name }}
          </div>
      </div>
      <div class="blog-content">
              <div>
                <img class="burger-icon" src="https://www.overtimebeer.ca/images/toggle.png" alt="" @click="burgerOpen" >
                <h1>{{ course.title }}</h1>
              </div>

            <div v-if="selectedTab.lesson_type!='quiz'" >
              <div v-for="sec in selectedTab.section" :key="sec.id" >
                  <div v-if="sec.type=='text'" @click="highlightsec(sec)"  v-bind:class="{'highlighted-sec':selectedSec==sec,'normal-sec': selectedSec!=sec}">
                          <div v-if="sec.type=='text'" class="course-text">
                               <Markdown :source="sec.content" />
                          </div>


                        <div v-if="updateForm && sec.id==selectedSec.id">
                            <form  @submit.prevent="submitForm">
                              <select class="section-form-element" id="section_type" name="section_type" v-model="usectionType">
                                <option class='form-label' value="" disabled selected hidden>Select Content Type</option>
                                <option class='form-label' value="code">Code</option>
                                <option class='form-label' value="image">Image</option>
                                <option class='form-label' value="text">Text</option>
                                <option class='form-label' value="video">Video</option>
                                <option class='form-label' value="list">List</option>
                              </select>
                                    <textarea name="" id="" cols="30" rows="10" class="text-area" v-model="contentText"></textarea>
                              <button @click="updatesec"  class="form-submit-button" type="submit">Submit</button>
                            </form> 
                        </div>
                        <div v-if="sec.id==selectedSec.id">
                              <button class='edit-button' @click="editsec">Edit</button>
                              <button class='delete-button' @click="deletesec">Delete</button>
                        </div>
                        <p>{{updateRes}}</p>
                  </div>
                  <div v-if="sec.type=='image'" class="image-content" @click="highlightsec(sec)"  v-bind:class="{'highlighted-sec':selectedSec==sec,'image-content': selectedSec!=sec}">
                        <img :src="`${sec.content}`" class="page-image" alt="whatever bruh">
                            <div v-if="updateForm && sec.id==selectedSec.id">
                            <form  @submit.prevent="submitForm">
                              <select class="section-form-element" id="section_type" name="section_type" v-model="usectionType">
                                <option class='form-label' value="" disabled selected hidden>Select Content Type</option>
                                <option class='form-label' value="code">Code</option>
                                <option class='form-label' value="image">Image</option>
                                <option class='form-label' value="text">Text</option>
                                <option class='form-label' value="video">Video</option>
                                <option class='form-label' value="list">List</option>
                              </select>
                                    <textarea name="" id="" cols="30" rows="10" class="text-area" v-model="ucontentText"></textarea>
                              <button @click="updatesec"  class="form-submit-button" type="submit">Submit</button>
                            </form> 
                        </div>
                        <div v-if="sec.id==selectedSec.id">
                               <button class='edit-button' @click="editsec">Edit</button>
                              <button class='delete-button' @click="deletesec">Delete</button>
                        </div>
                  </div>
                   <div v-if="sec.type=='code'" class="code-content" @click="highlightsec(sec)"  v-bind:class="{'highlighted-sec':selectedSec==sec,'image-content': selectedSec!=sec}">
                      <Prism language="python">
                        <pre>
                          {{sec.content}}
                        </pre>
                      </Prism>
                          <div v-if="updateForm && sec.id==selectedSec.id">
                            <form  @submit.prevent="submitForm">
                              <select class="section-form-element" id="section_type" name="section_type" place-holder="select content type" v-model="usectionType">
                                <option class='form-label' value="" disabled selected hidden>Select Content Type</option>
                                <option class='form-label' value="code">Code</option>
                                <option class='form-label' value="image">Image</option>
                                <option class='form-label' value="text">Text</option>
                                <option class='form-label' value="video">Video</option>
                                <option class='form-label' value="list">List</option>
                              </select>
                                    <textarea name="" id="" cols="30" rows="10" class="text-area" v-model="ucontentText"></textarea>
                              <button @click="updatesec"  class="form-submit-button" type="submit">Submit</button>
                            </form> 
                        </div>
                        <div v-if="sec.id==selectedSec.id">
                                <button class='edit-button' @click="editsec">Edit</button>
                              <button class='delete-button' @click="deletesec">Delete</button>
                        </div>
                    </div>
                </div> 
            </div>  

           
            <div v-else>
              <div class="main-content">
              <div class="quiz-content">
              <div v-show="showscore" class="score-content">
                <span class="pi pi-trophy" style="font-size: 1.6rem"></span> 
                <div class="score-text">
                <h2>   Your score is {{score}} out of {{selectedTab.exercise.length}}</h2>
                <h3>Percentage Score: {{(score/selectedTab.exercise.length).toFixed(2)*100}}% </h3>
                </div>
                <button v-show="!showsolutions" class="submit-button" @click="displaysols">Show Solutions</button>
                <hr class="score-divider">
              </div >
                  <div v-show="showsolutions" class="question-content" v-for="q in selectedTab.exercise" :key="q.id">
                    
                    <div v-if="q.type=='singleCorrect'">
                        <div class="question-text">
                            <div class="numbering">{{q.id }}</div>
                            <div class= "text-details">
                                <pre><h4>{{q.text}}</h4></pre>

                                
                                <label><input class="input-form" type="radio" :name="q.id" :value="q.optiona" v-model="q.selecteda" >{{q.optiona}}</label><br>
                                
                                <label><input type="radio" :name="q.id" :value="q.optionb" v-model="q.selecteda" >{{q.optionb}}</label><br>
                                
                                <label><input type="radio" :name="q.id" :value="q.optionc"  v-model="q.selecteda">{{q.optionc}}</label><br>
                            
                                <label><input type="radio" :name="q.id" :value="q.optiond"  v-model="q.selecteda">{{q.optiond}}</label><br>  
                                <p v-show="showscore">Your Answer: {{q.selecteda}}</p>
                            <p v-show="showscore">Correct Answer: {{q.correct}}</p>
                        </div>
                </div>


                </div>
                  <div v-else-if="q.type=='fillblanks'">
                    <div class="question-text"> 
                      <div class="numbering">
                          {{q.id }}
                      </div>
                      <div class= "text-details">
                        <pre><h4> {{q.text}} <input type="text" v-model="q.selecteda"> {{q.text2}}</h4></pre> 
                          <p v-show="showscore">Your Answer: {{q.selecteda}}</p>
                          <p v-show="showscore">Correct Answer: {{q.correct}}</p>
                      </div>
                    </div>
                </div>


                  <div v-else>
                    <div class="question-text">
                      <div class="numbering">
                          {{q.id }}
                      </div>
                    <div class="text-details">
                      <pre><h4>{{q.text}}</h4></pre>
                          
                          <label><input type="checkbox" :id="q.optiona" :value="q.optiona"  v-model="q.selectedb" >{{q.optiona}}</label><br>
                          
                          <label><input type="checkbox" :id="q.optionb" :value="q.optionb"  v-model="q.selectedb">{{q.optionb}}</label><br>
                          
                          <label><input type="checkbox" :id="q.optionc" :value="q.optionc"  v-model="q.selectedb">{{q.optionc}}</label><br>
                          
                          <label><input type="checkbox" :id="q.optiond" :value="q.optiond"  v-model="q.selectedb">{{q.optiond}}</label><br>
                          <p v-show="showscore">Your Answer: {{q.selectedb}}</p>
                          <p v-show="showscore">Correct Answer: {{q.correct}}</p>    
                      </div>  
                  </div>
                </div>
      
              </div>
                    <p v-for="cour in course" :key="cour.id">{{ cour.content }}</p>
                    <button v-show="aftersubmit" @click="evaluation" class="submit-button">Submit</button>
                  
                
                
                </div>
              </div>
          </div>

        <div class="prev-next">
              <button class="prev" @click="prevTab"> Previous</button>
              <button class="next" @click="nextTab">Next</button>
        </div>
         <!-- <Feedback /> -->
          <select class="form-element" id="form_type" name="form_type" v-model="formType">
                <option class='form-label' value="lesson">Lesson</option>
                <option class='form-label' value="content">Content</option>
                <option class='form-label' value="hide">Hide</option>
                <option class='form-label' value="" disabled selected hidden>Select Content Type</option>

          </select>
         <div v-if="formType=='lesson'" class='form-container'>
          <form  @submit.prevent="submitForm">
              <label class='form-label' for="name">Lesson Name:</label>
              <input class="form-element" type="text" id="name" name="name" v-model="lessonName">
              <label class='form-label' for="lesson_type">Select lesson type:</label>
              <select class="form-element" id="lesson_type" name="lesson_type" v-model="lessonType">
                <option class='form-label' value="quiz">Quiz</option>
                <option class='form-label' value="content">Content</option>
              </select>
               <button @click="createlesson"  class="form-submit-button" type="submit">Submit</button>
            </form>
            </div> 
            <!-- <div v-if="formType=='content'" class="lesson-form-container">
             <form >
               <select class="section-form-element" id="section_type" name="section_type" v-model="sectionType">
                <option class='form-label' value="" disabled selected hidden>Select Content Type</option>

                <option class='form-label' value="code">Code</option>
                <option class='form-label' value="image">Image</option>
                <option class='form-label' value="text">Text</option>
                <option class='form-label' value="video">Video</option>
                <option class='form-label' value="list">List</option>
                <option class='form-label' value="file">File</option>

              </select>
                <input placeholder="Enter title" v-model="secTitle" type="text">
                    <textarea name="" id="" cols="30" rows="10" class="text-area" v-model="contentText"></textarea>
               <button @click="createsection"  class="form-submit-button" >Submit Content</button>
            </form> 
         </div> -->
     <!-- REPLACE YOUR SECOND FORM BLOCK WITH THIS -->
        <div v-if="formType=='content'" class="lesson-form-container">
          <!-- 1. Added @submit.prevent here to stop the page from reloading -->
          <form @submit.prevent="createsection">
            <select class="section-form-element" id="section_type" name="section_type" v-model="sectionType">
              <option class='form-label' value="" disabled selected hidden>Select Content Type</option>
              <option class='form-label' value="code">Code</option>
              <option class='form-label' value="image">Image</option>
              <option class='form-label' value="text">Text</option>
              <option class='form-label' value="video">Video</option>
              <option class='form-label' value="list">List</option>
              <option class='form-label' value="file">File</option>
            </select>
            
            <input placeholder="Enter title" v-model="secTitle" type="text">
            <textarea name="" id="" cols="30" rows="10" class="text-area" v-model="contentText"></textarea>
            
            <!-- 2. Set type="submit" and removed the @click modifier so the form handles the event -->
            <button class="form-submit-button" type="submit">Submit Content</button>
          </form> 
        </div>

     
        </div>
    </div>
</div>


<div v-else class="landing-page-content">
       <div class="container">
          <div class="header">
            <h1>{{ course.title }}</h1>
            <p class="wr" >{{ course.short_desc }}</p>
            <p class="price">${{ course.price }}</p>
            <button class="enroll-button">Enroll</button>
            <button class="cart-button">Add to Cart</button>
          </div>
        </div>
        <div class="skill-container">
            <h2>Skills</h2>
            <div v-for="(skill, index) in course.skills" :key="index" class="skill-section"> <span class="pi pi-check-circle"></span>  {{ skill }}</div>

            
        </div> 
    <!-- <hr class="main-divider"> -->
          <div class="lesson-container">
                <h2>Lessons</h2>
            <div v-for="(les, index) in course.lesson" :key="index" class="lesson-section">
              <hr class="lesson-divider">
              <h4>{{index+1}}. {{ les.name }}</h4>
               <p>This has been a very good experience</p>
               </div>
          
          </div> 
          <div class="desc-container">
            <h2>Description</h2>
             <p>{{ course.description}}</p>
          </div>

</div>
</template>

<script>
//import Feedback from './Feedback.vue'
import TopPanel from './TopPanel.vue'; 
import { supabase } from '@/supabase.js';
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

import Prism from 'vue-prism-component'
import 'prismjs/components/prism-python'
import { default as cstore } from '@/stores/dataStore.js';
import { default as ustore } from '@/stores/authStore.js';
import Markdown from 'vue3-markdown-it';




export default {
  data(){
    return{
      cstore:cstore,
      ustore:ustore,
      course:{},
      completed:false,
      selectedTab:{},
      selectedSec:{},
      burgerCon:true,
      hidata:false,
      score:0,
      picked:null,
      showscore:false,
      showsolutions:true,
      aftersubmit:true,
      quesindex:0,
      lessonName:'',
      lessonType:'',
      contentText:'',
      sectionType:'',
      contentList:[],
      updateForm:false,
      ucontentText:'',
      usectionType:'',
      formType:'',
      updateRes:'',
      secTitle:null,
    }
  },

mounted() {
  const cid = this.$route.params.id;
  if (this.cstore.courseData.length > 0) {
    this.course = this.cstore.courseData.find(post => post.id == cid);
    this.selectedTab = this.course.lesson[0];
   
  } else {
    // Wait for the data to be loaded
    this.$watch('cstore.courseData', (newVal) => {
      if (newVal.length > 0) {
        this.course = newVal.find(post => post.id == cid);
        this.selectedTab = this.course.lesson[0];

      }
    });
  }

},
      
async created(){
// this.course = this.cstore.courseData.find(post=>post.id==cid);
// this.selectedTab = this.course.lesson[0];
  
//         localStorage.setItem('userRole', this.profile.role);
  window.addEventListener('scroll', this.checkScrollPosition);
},

unmounted() {
  window.removeEventListener('scroll', this.checkScrollPosition);
},

components: {
  TopPanel,
  Prism,
  Markdown

  // Feedback,
},

methods: {
  navigateToSubtopic() {
  },


highlightTab (subtopic){
this.selectedTab=this.subtopic
for (let i = 0; i < this.course.lesson.length; i++) {
    if (this.course.lesson[i].name===subtopic.name){
        // this.course.subtopics[i].condition=true
        this.selectedTab=this.course.lesson[i]
        this.burgerCon=true
        this.$router.push({name:'course1',params:{id:this.id,subid:this.selectedTab.name}});
      }
      else{
        // this.course.subtopics[i].condition=false
        console.log('bruh')

      }
    // this.$router.push({name:'course1',params:{id:this.id,subid:this.selectedTab.title}});

}
},

highlightsec (sec){
this.selectedSec=this.sec
for (let i = 0; i < this.selectedTab.section.length; i++) {
    if (this.selectedTab.section[i].id===sec.id){
        this.selectedSec=this.selectedTab.section[i]
      }
      else{
        console.log('bruh')

      }

}
},




nextTab(){
   const idx = this.course.lesson.indexOf(this.selectedTab)
    this.selectedTab=this.course.lesson[idx+1]
},

prevTab(){
   const idx = this.course.lesson.indexOf(this.selectedTab)
    this.selectedTab=this.course.lesson[idx-1]
},


courseNavigation(){
this.$router.push({name:'course1',params:{id:this.id,subid:this.title}});

},


burgerOpen(){
  this.burgerCon=!this.burgerCon
},


checkScrollPosition() {
const scrollTop = window.scrollY || document.documentElement.scrollTop;
const windowHeight = window.innerHeight;
const documentHeight = document.documentElement.scrollHeight;

if (scrollTop + windowHeight >= documentHeight - 10) {
      console.log('Bottom of the page reached!');
      this.selectedTab.completed = true;

}
  },

    showhi(){
      this.hidata = !this.hidata
    },
    evaluation(){
      for (let i = 0; i < this.selectedTab.exercise.length; i++) {
        const currquestion = this.selectedTab.exercise[i]
     if (currquestion.type!="multiCorrect"){
      if(currquestion.selecteda!=null){
        if(currquestion.selecteda.toLowerCase().replace(/\s/g, "")===currquestion.correct.toLowerCase().replace(/\s/g, "")){
          this.score = this.score+1
        }
      }
     }
     else if ((currquestion.selectedb.join(',').split('').sort().join(''))==(currquestion.correct.split('').sort().join('')) && currquestion.type=="multiCorrect"){
         this.score = this.score+1
      }
      this.aftersubmit=false
      this.showscore=true
      this.showsolutions=false


}
    
        
    },

displayscore(){
  this.showscore = true
},

editsec(){
 this.updateForm=!this.updateForm
 this.ucontentText=this.selectedSec.content
},

async updatesec(){
  const { error } = await supabase
  .from('section')
  .update({ content: this.ucontentText })
  .eq('id', this.selectedSec.id)
  cstore.refresh()
    this.updateRes= error

},

async deletesec(){
const response = await supabase
  .from('section')
  .delete()
  .eq('id', this.selectedSec.id)
  cstore.refresh()
  console.log(response)
},


displaysols(){
this.showsolutions = true;
} ,

async createlesson(){
  try {
  const { error } = await supabase
  .from('lesson')
  .insert({ 
   name: this.lessonName,
   course_id:this.course.id,
   lesson_type:this.lessonType
    })

     cstore.refresh();
  if (error) throw error;
        alert('Form submitted successfully!');
  } catch (error) {
     console.error('Error submitting form:', error.message);
      alert('Error submitting form. Please try again.');
  }

},

async  uploadFile() {
  const input = document.getElementById('fileInput');
  const file = input.files[0];
  if (!file) return alert("Please select a file!");

  // 1. Get a signed upload URL from your backend
  const res = await fetch(`/api/r2-signed-url?filename=${encodeURIComponent(file.name)}`);
  const { signedUrl } = await res.json();

  // 2. Upload the file directly to R2
  const uploadRes = await fetch(signedUrl, {
    method: 'PUT',
    body: file,
  });

  if (uploadRes.ok) {
    alert("✅ Upload successful!");
  } else {
    alert("❌ Upload failed.");
  }
},



async createsection(){
console.log('triggering the function')
  const { error } = await supabase
  .from('section')
  .insert({ 
   type: this.sectionType,
   content:this.contentText,
   lesson_id:this.selectedTab.id,
   section_title:this.secTitle,
    })

  cstore.refresh()
  if (error) 
     {
      console.log(error)
  }

},




    
 
  }

};
</script>

<style scoped>


.main-content {
display: flex;
max-width: 1500px;
min-height: 120vh;
}

.page-image {
  margin-top: 4%;
  width: 100%;
  height: auto;
  margin-bottom: 4%;  
}

.subtopic-menu {
  width: 18%; /* Adjust the width as needed */
  /* background-color:  #fbfaf9 ; */
  box-shadow: 2px 0 5px rgba(0.5, 0.5, 0, 0.1);
  background: var(--sec-col);

}

/* ul {
  list-style-type: none;
  padding: 0;
} */

.subtopic-element {
  cursor: pointer;
  padding: 5.5%;
  /* box-shadow: 1px 0 1px rgba(0.4, 0.4, 0, 0.1); */
  font-weight: bold;
  color: var(--sec-col);
}

.burger-icon {
  width: 0px;
  height: 0px;
 visibility: hidden;
}


.subtopic-element:hover {
  /* background: #ffffcc; */
  background: var(--prime-col);
  /* color: #1a1a1a; */
  color: #bfbfbf;
  box-shadow: 2px 0 5px rgba(0.5, 0.5, 0, 0.1);
}

.highlighted-tab{
  /* background-color:#ffff99; */
  background: hsl(0, 0%, 10%);
  color: cyan;
  font-weight: bold;
}


.normal-tab{

  font-weight: bold;
  /* color: #737373; */
  color: #bfbfbf;
}


.blog-content {
  text-align: center;
  width: 82%;
  /* overflow: auto; */
  /* color: rgb(65, 63, 68); */
  color:#f2f2f2;
  /* background: #ffffe6; */
  /* margin: 20 px; */
  background:var(--prime-col);
  padding-left: 7%;
  padding-right: 7%;
  /* padding: 10%; */
  /* font-weight: 470; */
}

.code-content{
  max-width: 100%;
   /* border-style: solid;
  border-width: 1px;
  border-color: #cccccc;
  border-radius: 5px ; */
  margin: 0%;
  padding: 0%;

}

.landing-page-content{
  background-color:  #2f2b3a;
    color:whitesmoke;
}



.container {
    max-width: 100%;
    max-height: 400px;
    /* margin: 50px auto; */
    color:whitesmoke;
    padding: 20px;
    /* background-color: #001233; */
    background-color:#1a1625;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid gray;
  }
.header {
  max-width: 400px;
  text-align: left;
  margin-left: 8%;
  margin-top: 50px;
  margin-bottom: 50px;
}
.lesson-list {
  list-style-type: none;
  padding: 0;
}
.lesson-item {
  border-bottom: 1px solid #ddd;
  padding: 10px 0;
}
.details {
  margin-top: 30px;
}
.details ul {
  list-style-type: none;
  padding: 0;
}
.details li {
  padding: 8px 0;
}

.wr{
  margin: 0;
  padding: 0;
  line-height: 1.5;
}

.price {
      font-size: 1.6em;
}

.enroll-button,.cart-button{
width: 8em;
padding: 12px;
font: bold 10 pt Helvetica;
margin-right:2em;
border-radius: 4px;
color: #001233;
cursor: pointer;
font-size: 1em;
background-color: #ffff99;
border: 1px solid #ddd;
transition: background-color 0.3s;
justify-content: center;

}

.skill-container{
max-width: 85%;
text-align: left;
margin-left: 8%;
margin-right: 8%;
margin-top: 50px;
margin-bottom: 50px;
padding:30px;
border: 1px solid gray;
box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
border-radius: 2px ;
background-color:#1a1625;
color:whitesmoke;
border: 1px solid gray;
border-radius: 5px ;

}


.highlighted-sec{
background:#141717 ;
box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
padding: 20px;
border: 1px solid gray;

}

.skill-section{
  margin-bottom: 10px;
  border-width: 1px;
}

.main-divider{
 /* background-color: red; */
 border-color: #ffffff; 
 max-width: 84%;
 margin-left: 8%;
 margin-bottom: 3%;
 margin-top: 3%;
border-width: 1px;

}

.lesson-divider{
  border-color: #ffffff; 
}

.lesson-container{
max-width: 85%;
text-align: left;
margin-left: 10%;
margin-right: 8%;
}

.desc-container{
max-width: 85%;
margin-top:8%;
text-align: left;
margin-left: 10%;
margin-right: 8%;
}




.lesson-section{
  margin-bottom: 10px;
  border-width: 1px;
}
  

.course-text{
  line-height: 1.5;
  /* color: #404040; */
  text-align: left;
  color:#f2f2f2;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 1.1rem;

}

.col-subtopic-menu{
  width: 0vw;
  /* visibility: hidden; */
}

.exp-subtopic-menu{
  width: 0vw;
  /* visibility: hidden; */
}


.prev-next{
  display: flex;
  justify-content: space-between;
}

.prev{
  width:150px;
  height:50px;
  margin-top:50px;
  padding: 20 px;
  border-radius: 5px;
  background: #1a1625;
  border: 1px solid gray;
  color: cyan;
}

.next{
  width:150px;
  height:50px;
  margin-top:50px;
  border-radius: 5px;
  background: #1a1625;
  border: 1px solid gray;
  color: cyan;

}


.quiz-content{
  /* width: 80vw; */
  max-width: 85%;
  align-items: center;
  justify-content: center;
  padding-left: 5vw;
  padding-right: 5vw;
  padding-top: 5vh;
  padding-bottom: 7vh;

}

.question-text{
  display: flex;
}

.question-content{
  color: white;
  padding: 20px;
  font-size: 18px;
  overflow: auto;
  border: 1px solid gray;
  margin-bottom: 3%;
  background:  #2f2b3a;
  border-radius: 7px;
  min-height: 25vh;
  text-align: left;
}

.question-content:hover{
  border: 1px solid cyan;
}

.numbering{
  margin-top:1%;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  padding: 7px;
  background: #ffff99;
  /* border: 3px solid cyan; */
  color: #1a1625;
  text-align: center;
  margin-right: 6vw;
  font: 28px Hevelentica,Arial, sans-serif;

}

.text-details{
  max-width: 85%;
}


:deep(code) {
  color: cyan !important;
}



pre {
    white-space: pre-wrap;      
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
}


.submit-button{
  width:170px;
  background-color: #ffff99;
  color: #1a1625;
  border: 1px solid gray;
  font-size: 16px;
  margin-bottom: 20px;
  margin-top: 20px;
  padding: 8px;
  margin-top:8px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ddd;
  transition: background-color 0.3s;
  text-align: center;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}

.submit-button:hover{
  border: 1px solid cyan;
}

.score-content{
  color:white;
  margin-bottom: 10%;
}

.score-text{
  margin-bottom: 100px;
}

.main-divider{
 /* background-color: red; */
 border-color: #ffffff; 
 max-width: 84%;
 margin-left: 8%;
 margin-top: 50px;
}




.form-container{
  display: block;
  width: 350px;
  margin: 0 auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
  padding: 30px;
  font-size:18px;

}

.lesson-form-container{
  display: block;
  width: 750px;
  margin: 0 auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
  padding: 30px;
  font-size:18px;

}




.form-element{
  width: 350px;
  height: 25px;
  margin-bottom: 15px ;
  background:  #1a1625;
  color:whitesmoke;
  resize:none;
}


.section-form-element{
  width: 750px;
  height: 25px;
  margin-bottom: 15px;
  background:  #1a1625;
  color:whitesmoke;
  resize:none;
}



.form-submit-button{
  height: 50px;
  width: 260px;
  border-radius: 8px;
  background: #290066;
  text-align: center;
  color: white;
  font-size: 17px;
}

.form-label{
   display: table-cell;
    vertical-align: middle;
    height: 50px;
    
}

.text-area{
  width: 55vw;
  height: 20vh;
  margin-bottom: 2%;
  background: #2f2b3a ;
  resize: none;
  color: aliceblue;
}

.edit-button{
  background: gray;
  width:40x;
  margin-right: 5px;
  padding: 5px;
}

.delete-button{
  background: red;
  width:40x;
  margin-left: 5px;
  padding: 5px;

}

/*media queries */

@media only screen and (max-width: 800px) {



.blog-content{
  width: 100vw;
}

.subtopic-menu{
  width: 0vw;
}

.col-subtopic-menu{
  width: 0vw;
}

.exp-subtopic-menu{
  width: 45vw;
  /* display: block; */
  position: absolute;
  min-height: 100vh;
  z-index: 1000;
  box-shadow: 2px 0 5px rgba(0.5, 0.5, 0, 0.1);
  background: var(--sec-col);

}


.burger-icon {
  width: 10vw;
  height: 5vh;
  cursor: pointer;
  margin-top: 2vh;
  margin-right: 72vw;
  visibility: visible;
  padding: 0%;
}

.enroll-button,.cart-button{
  margin-top: 5px;
  width: 72vw;
  margin-right:0em;
}


.question-content{
  font-size:15px ;
 }

 .numbering{
  margin-top:15px;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  padding: 7px;
  /* background: #ffff99;
  /* border: 3px solid cyan; */
  /* color: #1a1625;
  text-align: center;
  margin-right: 6vw; */
  font: 16px Hevelentica,Arial, sans-serif;

}

}

</style>